import { mapGetters } from "vuex";

import comboComponent from "@/components/child/form/combo.vue";
import dateTimePickerComponent from "@/components/child/form/datetimepicker.vue";
import { GridAction } from "@/components/child/grid/gridAction";
import { GridColors, GridColumn, GridColumnSearchColor, GridColumnType } from "@/components/child/grid/gridColumn";
import ImpressaoComponent from "@/components/child/impressao/impressaoComponent";
import impressaoComponent from "@/components/child/impressao/impressaoComponent.vue";
import AzulCargoComponent from "@/components/parent/expedicao/azulCargo";
import azulCargoComponent from "@/components/parent/expedicao/azulCargo.vue";
import TentativasEntregaComponent from "@/components/parent/expedicao/tentativasEntrega";
import tentativasEntregaComponent from "@/components/parent/expedicao/tentativasEntrega.vue";
import { Component, Prop, Watch } from "@/decorators";
import ModeloEspecifico from "@/models/enum/modeloEspecifico";
import TipoBuscaVenda from "@/models/enum/tipoBuscaVenda";
import VendaEntregaStatus from "@/models/enum/VendaEntregaStatus";
import ModeloImpressaoModel from "@/models/modeloImpressao/modeloImpressaoModel";
import PaginationModel from "@/models/paginationModel";
import VendaModel, { VendaListParameters } from "@/models/vendaModel";
import ModeloImpressaolService from "@/services/modeloImpressaoService";
import NotaFiscalEletronicaEmissaoService from "@/services/notaFiscal/notaFiscalEletronicaEmissaoService";
import localEntregaService from "@/services/transporte/localEntregaService";
import VendaService from "@/services/vendaService";
import vendedorService from "@/services/vendedorService";
import { Getters } from "@/store/store";
import { convertToDateInput, convertToDateWithTimeInputString } from "@/utils/common/date";
import FileHelper from "@/utils/common/fileHelper";

import ListComponentBase from "../crud/listComponentBase";
import PrintModel from "../printModel/printModel";

const vendaService = new VendaService();
const notaFiscalEletronicaEmissaoService = new NotaFiscalEletronicaEmissaoService();

@Component({
    components: {
        dateTimePickerComponent,
        comboComponent,
        tentativasEntregaComponent,
        azulCargoComponent,
        impressaoComponent,
    },
    computed: {
        ...mapGetters(["VALIDAR_PERMISSAO_SOMENTE_CONSULTA", "GET_IS_ESTEREIS"] as Getters),
    },
})
export default class ListEntregaComponent extends ListComponentBase<VendaModel> {
    // State computed props
    VALIDAR_PERMISSAO_SOMENTE_CONSULTA: (telaDescricao: string) => boolean;
    GET_IS_ESTEREIS: () => Promise<boolean>;

    private tentativasEntregaComponent: TentativasEntregaComponent = null;
    private azulCargoComponent: AzulCargoComponent = null;
    private impressaoComponent: ImpressaoComponent = null;

    extraActions: Array<object> = [];
    extraActionTentativa: Array<GridAction> = [];
    extraActionEntregue: Array<GridAction> = [];
    extraActionAzulCargo: Array<GridAction> = [];
    extraActionRomaneio: Array<GridAction> = [];

    @Prop({ type: Boolean, default: false }) CalledByShortCut: boolean;

    usuariosOptions: Array<Object> = [];
    locaisEntregaOptions: Array<Object> = [];
    statusEntregaOptions: Array<Object> = [
        { text: "Entregue", value: VendaEntregaStatus.Entregue },
        { text: "Não Entregue", value: VendaEntregaStatus.NaoEntregue },
    ];

    isHidden = false;
    filtro: Array<Object> = [];
    dataFilter1: Date = null;
    dataFilter2: Date = null;
    tipoBuscaVenda = 0;
    vendedor = null;
    localEntregaId = null;
    statusEntrega = null;
    somenteConsultaVenda = false;
    isEstereis = false;
    situacao = 0;

    subDataName = "itens";

    tipoBuscaVendaOptions: Array<Object> = [
        { text: "Codigo da Venda", value: TipoBuscaVenda.Venda },
        { text: "Cliente", value: TipoBuscaVenda.Cliente },
        { text: "Manipulacao", value: TipoBuscaVenda.Manipulacao },
        { text: "Paciente", value: TipoBuscaVenda.Paciente },
    ];

    gridSelectedValues: Array<VendaModel> = [];

    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumnSearchColor("codigo", "C\u00f3digo", GridColumnType.String),
            new GridColumnSearchColor("situacaoDescricao", "Situação", GridColumnType.String, false),
            new GridColumnSearchColor("clienteNome", "Cliente", GridColumnType.String),
            new GridColumnSearchColor("localEntregaDescricao", "Local de entrega", GridColumnType.String),
            new GridColumnSearchColor("dataEntrega", "Data Entrega", GridColumnType.DateTime),
            new GridColumnSearchColor("valorFinal", "Valor", GridColumnType.Money),
            new GridColumnSearchColor("statusTentativaDescricao", "Status Entrega", GridColumnType.String, false),
            new GridColumnSearchColor("quantidadeTentativas", "Qtd Tentativas", GridColumnType.Integer, false),
        ];
    }

    get gridColumnsVinculos(): Array<GridColumn> {
        return [
            new GridColumn("produtoDescricao", "Produto", GridColumnType.String),
            new GridColumn("continuo", "Continuo", GridColumnType.Boolean),
            new GridColumn("quantidade", "quantidade", GridColumnType.DecimalPonto),
            new GridColumn("valorUnitario", "valorUnitario", GridColumnType.Money),
            new GridColumn("valorTotal", "valorTotal", GridColumnType.Money),
            new GridColumn("dataValidade", "Data Validade", GridColumnType.Date, false),
        ];
    }

    conditionShowSubData(it) {
        return it["itens"]["length"] > 0;
    }

    private async beforeMount() {
        this.setProps(new VendaService(), "venda", "dataEntrega", false, "desc");
        this.isEstereis = await this.GET_IS_ESTEREIS();
    }

    public async loadMethod() {
        this.tentativasEntregaComponent = this.$refs.tentativasEntregaComponent as TentativasEntregaComponent;

        const customParameters: VendaListParameters = {
            dataInicial: convertToDateWithTimeInputString(this.filtro[0]),
            dataFinal: convertToDateWithTimeInputString(this.filtro[1]),
            vendedor: this.vendedor,
            localEntrega: this.localEntregaId,
            statusEntrega: this.statusEntrega,
        };

        return await vendaService
            .listVendasEntregas(
                this.gridFilterKey,
                this.gridSortKey,
                this.gridSortOrder,
                this.pags ? 1 : this.pageIndex,
                this.pags ? 999999 : this.pageSize,
                customParameters,
            )
            .withLoading()
            .resolveWithJSON<PaginationModel<VendaModel>>();
    }

    public async onMarcarComoEntregue(vendaId: number) {
        try {
            const sucesso = await vendaService.marcarComoEntregue(vendaId).withLoading().resolveWithoutJSON();

            if (sucesso) {
                await this.$showInclusaoUpdate(vendaId);
                await this.load();
            }
        } catch {}
    }

    public async afterLoad() {
        try {
            this.gridData["dataDe"] = this.filtro[0] ? this.filtro[0].toString() : " ";
            this.gridData["dataAte"] = this.filtro[1] ? this.filtro[1].toString() : " ";
            this.gridData["status"] = this.filtro[2] ? this.filtro[2].toString() : " ";

            this.isHidden = false;

            this.usuariosOptions = await vendedorService.comboCached(this.usuarioLogado.franquiaId);
            this.locaisEntregaOptions = await localEntregaService.comboCached(this.usuarioLogado.franquiaId);
            this.somenteConsultaVenda = this.VALIDAR_PERMISSAO_SOMENTE_CONSULTA("vendas");
        } catch {}

        this.extraActions.splice(0);
        this.extraActionAzulCargo.splice(0);
        this.extraActionEntregue.splice(0);
        this.extraActionTentativa.splice(0);
        this.extraActionRomaneio.splice(0);

        for (let i = 0; i < this.gridData.length; i++) {
            if (this.isEstereis) {
                this.extraActionAzulCargo.push(
                    new GridAction(
                        "azul-cargo",
                        this.$t("__.ts.enviarMinutaAzulCargo") as string,
                        "fa fa-plane",
                        GridColors.BLUE,
                        !this.gridData[i].codigoAWB,
                    ),
                );
            }
            this.extraActionEntregue.push(
                new GridAction("entregue", this.$t("__.ts.marcarEntregue") as string, "fa fa-check", GridColors.GREEN),
            );
            this.extraActionTentativa.push(
                new GridAction(
                    "tentativa",
                    this.$t("__.ts.tentativasEntrega") as string,
                    "fa fa-truck",
                    GridColors.GREEN,
                ),
            );
            this.extraActionRomaneio.push(
                new GridAction(
                    "imprimir-romaneio",
                    this.$t(
                        "__.Components.parent.home.fastaction.entregas.entregas_vue_html.imprimirRomaneio",
                    ) as string,
                    "fa fa-print",
                    GridColors.GRAY,
                ),
            );
        }
        this.extraActions.push(this.extraActionAzulCargo);
        this.extraActions.push(this.extraActionEntregue);
        this.extraActions.push(this.extraActionRomaneio);
        this.extraActions.push(this.extraActionTentativa);
    }

    private getFormValues(listaFiltro) {
        this.filtro = [];
        this.filtro.push(listaFiltro.target.elements.dataFilter1.value);
        this.filtro.push(listaFiltro.target.elements.dataFilter2.value);

        this.load();
    }

    private onSelectedValuesChanged(values: Array<VendaModel>) {
        this.gridSelectedValues = values;
    }

    private async imprimirRomaneio() {
        try {
            const modelosVenda = await new ModeloImpressaolService()
                .getByModeloEspecifico("venda", ModeloEspecifico.Romaneio)
                .resolveWithJSON<ModeloImpressaoModel>();

            const pages = await vendaService
                .getManyHTMLPage(
                    this.gridSelectedValues.map(x => x.id),
                    modelosVenda.id,
                    1,
                    this.usuarioLogado.id,
                )
                .withLoading();

            const printModel = new PrintModel();
            printModel.showHTMLOnBrowser(pages.pageHtml, true);
        } catch (e) {
            await this.$showError(this.$t("__.ts.erroModeloImpressaoSemConteudo"), e.message);
        }
    }

    private async exportarXMLTransporte() {
        try {
            const listIdsVendas = this.gridSelectedValues.map(p => p.id);
            const response = await notaFiscalEletronicaEmissaoService
                .downloadXMLEmLote(listIdsVendas)
                .resolveWithResponse()
                .withLoading();

            if (response.ok) {
                const blob = await response.blob();
                const fileName = response.headers.get("Content-Disposition").split("filename=")[1].split(";")[0];

                FileHelper.download(blob, fileName, "application/zip");
            }
        } catch {}
    }

    @Watch("tipoBuscaVenda")
    private onTipoBuscaVenda() {
        this.load();
    }

    public async afterLoadPagination() {
        if (this.paginationParams.filtros != null) {
            this.filtro = this.paginationParams.filtros;
            if (this.filtro.length >= 0) {
                if (this.filtro[0]) {
                    this.dataFilter1 = convertToDateInput(this.filtro[0].toString());
                }
                if (this.filtro.length >= 1) {
                    if (this.filtro[1]) {
                        this.dataFilter2 = convertToDateInput(this.filtro[1].toString());
                    }
                }
            }
        }
    }

    private async onExtraActions(name: string, venda: VendaModel) {
        if (name.trim() == "tentativa") {
            this.tentativasEntregaComponent.show(venda.id);
        }
        if (name.trim() == "entregue") {
            this.onMarcarComoEntregue(venda.id);
        }
        if (name.trim() == "imprimir-romaneio") {
            this.impressaoComponent = this.$refs.impressaoComponent as ImpressaoComponent;

            await this.impressaoComponent.show({
                modelId: venda.id,
                tipoImpressao: "Venda",
                impressaoRotulo: false,
                impressaoSelecionarModelo: true,
                modeloEspecifico: ModeloEspecifico.Romaneio,
            });
        }
        if (name.trim() == "azul-cargo") {
            this.azulCargoComponent = this.$refs.azulCargoComponent as AzulCargoComponent;
            this.azulCargoComponent.show(venda.id);
        }
    }

    private onGenerated() {
        this.load();
    }
}
